import React, { useState, useEffect, useRef, useMemo } from "react";
import GenericTemplate from "../../templates/GenericTemplate";
import {
  apollo_useStyles,
  valueToOption,
  option_setpoint_attribute,
  options_matchtype,
  option_setpoint_cv_category,
  option_setpoint_action_category,
} from "../../atom/Apollo_styles";
import {APOLLO_SYSTEM_ADMIN, APOLLO_GROUP_OPERATOR, ApolloPageUsagePermission} from "../../atom/Apollo_Authorization";
import {ApolloBreadcrumbs} from "../../atom/Apollo_Breadcrumbs";

import { useForm, Controller } from "react-hook-form";
import { Link, useHistory } from "react-router-dom";

import { MeasureConditions } from "./HeraMeasureConditionEdit";

import Grid from "@material-ui/core/Grid";
import TextField from "@material-ui/core/TextField/TextField";
import Card from "@material-ui/core/Card/Card";
import CardContent from "@material-ui/core/CardContent";
import CardActions from "@material-ui/core/CardActions/CardActions";
import FormControlLabel from '@material-ui/core/FormControlLabel';

import Button from "@material-ui/core/Button";
import Checkbox from '@material-ui/core/Checkbox';
import Select from 'react-select';
import makeAnimated from 'react-select/animated';
import Typography from "@material-ui/core/Typography";
import Divider from "@material-ui/core/Divider";

import { ApolloContext } from "../../atom/Apollo_Context";
import axios from "axios";
import moment from "moment";
import Breadcrumbs from "@material-ui/core/Breadcrumbs";
import { ApolloMessage, CustomizedSnackbars } from "../../atom/Apollo_Mesasge";

import {
  Event,
  SetPointTagCreateRequest,
  SetPointExternalCreateRequest
} from "./HeraModel"

import { hera_events_path, hera_setpoints_path } from "../../atom/Apollo_links"

import {ApolloEventRecord, ItemList} from "../../atom/Apollo_EventRecord";
import {checkInvalidCharForName} from "../../common/Apollo_CommonUtil";

// エラーメッセージ
const ERROR_MESSAGE = [
  "データの取得に失敗しました",
];
// 警告メッセージ
const WARNING_MESSAGE = [
  "有効な測定ポイントの上限数を超えてしまうため、作成することができませんでした。他の有効な測定ポイントのステータスを「無効」にしてから、再度作成してください。",
]

const animatedComponents = makeAnimated();

/*
    画面名：
 */
const HeraSetPointEdit: React.FC = () => {
  const classes = apollo_useStyles();
  let history = useHistory();

  const handelGoback = () => {
    history.goBack();
  };

  const { state } = React.useContext(ApolloContext);

  const trackerId = state.current.trackerId

  const [conditionIndexes, setConditionIndexes] = useState<number[]>([]);
  const [events, setEvents] = useState<Event[]>([]);
  const [attributeType, setAttributeType] = useState(0);
  const [cvCategory, setCvCategory] = useState(1);
  const [actionCategory, setActionCategory] = useState(1);

  const { data, setmsg } = React.useContext(ApolloMessage);

  const [processing, setProcessing] = useState(false);

  const handleChangeCvCategory = (event: any) => {
    setCvCategory(event.value);
  };

  const handleChangeActionCategory = (event: any) => {
    setActionCategory(event.value);
  };

  const handleChangeStatus = (event: any) => {
    setAttributeType(event.value);
  };

  useEffect(() => {
    setmsg({
      type: "loading",
      payload: {
        ...data,
        loading: true
      }
    })
    const url = `${process.env.REACT_APP_API_ENDPOINT}${hera_events_path}/${trackerId}`
    axios.get(url, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${state.accesstoken}`,
      }
    })
      .then((response) => {
        setEvents(response.data.result)
      })
      .catch(err => {
        const errMsg = err.message ? err.message : ERROR_MESSAGE[0];
        setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: errMsg
          }
        });
      })
      .finally(() => {
        setmsg({
          type: "loading",
          payload: {
            ...data,
            loading: false
          }
        })
      })
  }, []);

    const options_event = events.map(event => ({ value: event.ID, label: event.name }));

  const addConditions = (index: number[]) => () => {
      if (index.length < 10) {
        setConditionIndexes(current => [...current, current.length > 0 ? Math.max(...current) + 1 : current.length]);
      }
  };
  const removeConditions = (index: number) => () => {
    setConditionIndexes(current => current.filter(i => i !== index));
  };

  const formHooks = useForm({
    mode: "onBlur",
    reValidateMode: "onBlur",
    shouldUnregister: true,
  });
  const { register, handleSubmit, control, errors, formState, watch, setValue, clearErrors } = formHooks;

  useEffect(() => {
    setConditionIndexes([]);
    setValue("urlPatterns", []);

    setValue("eventParameter", "");
    clearErrors(["urlPatterns", "EventID", "eventParameter"]);

    if (attributeType !== 1) {
      setValue("EventID", null);
    }
  }, [attributeType, setValue, clearErrors]);

  const watched = watch(["name", "eventParameter", "EventID", "urlPatterns"]);

  const canSubmit = useMemo(() => {
    if (formState.isSubmitting || processing) return false;
    if (!formState.isValid) return false;

    const { name, eventParameter, EventID, urlPatterns } = watched as any;

    // 共通必須：測定ポイント名
    if (!name || name.trim() === "") return false;

    // 測定手法未選択(0)はNG（初期表示時は未選択）
    if (attributeType === 0) return false;

    // 外部計測ツールによる測定
    if (attributeType === 2) {
      if (!eventParameter || eventParameter.trim() === "") return false;
      return true;
    }

    // トラッキングタグによる測定
    if (attributeType === 1) {
      if (!EventID?.value) return false;

      // URL条件が無いならOK
      if (conditionIndexes.length === 0) return true;

      // URL条件があるなら全行必須
      const patterns = urlPatterns ?? [];
      for (const idx of conditionIndexes) {
        const row = patterns[idx];
        if (!row?.pattern || row.pattern.trim() === "") return false;
        if (!row?.matchType?.value) return false;
      }
      return true;
    }

    return false;
  }, [
    watched,
    attributeType,
    conditionIndexes,
    formState.isSubmitting,
    formState.isValid,
    processing,
  ]);

  const onSubmit = handleSubmit(async (formData: any) => {
    if (formState.isSubmitting) return;
    if (processing) return;
    let isSuccess = false;
    let targetID = "";
    let targetName = "";

    const urlPatterns = formData.urlPatterns?.filter((pattern: any, index: number) => conditionIndexes.includes(index));

    let url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}/external`;

    if (attributeType === 2) {
      url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}/external`;
      const setPointCreateRequest: SetPointExternalCreateRequest = {
        name: formData.name,
        cv_category: cvCategory,
        action_category: actionCategory,
        eventParameter: formData.eventParameter
      }

      let itemList: ItemList[] = [
        {
          key: "測定ポイント名",
          beforeValue: "",
          afterValue: setPointCreateRequest.name,
        },
        {
          key: "CVカテゴリ",
          beforeValue: "",
          afterValue: valueToOption(cvCategory, option_setpoint_cv_category).label,
        },
        {
          key: "アクションカテゴリ",
          beforeValue: "",
          afterValue: valueToOption(actionCategory, option_setpoint_action_category).label,
        },
        {
          key: "測定手法",
          beforeValue: "",
          afterValue: valueToOption(attributeType, option_setpoint_attribute).label,
        },
        {
          key: "計測地点識別パラメータ名",
          beforeValue: "",
          afterValue: setPointCreateRequest.eventParameter,
        },
      ]
      // 実行時
      ApolloEventRecord({
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "execute",
        result: "",
        userID: state.userprofile.userId,
        userName: state.userprofile.userName,
        accessToken: state.accesstoken ,
        accountGroupID : state.current.accountGroupId,
        accountGroupName: state.current.accountGroupName,
        accountID : state.current.accountId,
        accountName: state.current.accountName,
        campaignID: "", // キャンペーンID
        campaignName: "", // キャンペーン名
        adGroupID: "", // 広告グループID
        adGroupName: "", // 広告グループ名
        menu: "",
        displayName: "測定ポイント新規登録画面",
        category: "測定ポイント",
        actionType: "作成",
        targetID: "",
        targetName: "",
        itemList: itemList,
      });

      setProcessing(true);
      await axios.post(
        url,
        setPointCreateRequest,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          }
        })
        .then((response) => {
          if (response.data.resultcode === 0) {
            isSuccess = true;
            if (response.data.result) {
              targetID = response.data.result[0].ID;
              targetName = setPointCreateRequest.name;
            }
            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: "success",
                message: "測定ポイント新規登録に成功しました"
              }
            });
          } else {
            console.log(response.data.message);
            const type: string = response?.data?.message === "有効可能上限数エラー" ? "warning" : "error"
            const message: string = response?.data?.message === "有効可能上限数エラー" ? WARNING_MESSAGE[0] : "測定ポイント新規登録に失敗しました"
            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: type,
                message: message
              }
            });
          }
        })
        .catch(() => {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "測定ポイント新規登録に失敗しました"
            }
          });
        }).finally(() => {
          // 実行結果
          ApolloEventRecord({
            eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
            logType: "result",
            result: isSuccess? "成功" : "失敗",
            userID: state.userprofile.userId,
            userName: state.userprofile.userName,
            accessToken: state.accesstoken ,
            accountGroupID : state.current.accountGroupId,
            accountGroupName: state.current.accountGroupName,
            accountID : state.current.accountId,
            accountName: state.current.accountName,
            campaignID: "", // キャンペーンID
            campaignName: "", // キャンペーン名
            adGroupID: "", // 広告グループID
            adGroupName: "", // 広告グループ名
            menu: "",
            displayName: "測定ポイント新規登録画面",
            category: "測定ポイント",
            actionType: "作成",
            targetID: targetID,
            targetName: targetName,
            itemList: itemList,
          });

          setProcessing(false);

            if (isSuccess) {
            history.goBack();
          }
        })

    } else if (attributeType === 1)  {
      url = `${process.env.REACT_APP_API_ENDPOINT}${hera_setpoints_path}/${trackerId}/tag`;
      const setPointCreateRequest: SetPointTagCreateRequest = {
        name: formData.name,
        cv_category: cvCategory,
        action_category: actionCategory,
        eventID: formData.EventID.value,
        urlTarget: conditionIndexes.length > 0 ? true : false,
        urlPatterns: urlPatterns?.map((urlPattern: any) => (
          {
            pattern: urlPattern.pattern,
            matchType: urlPattern.matchType.value
          }
        )),
      }
  
      if (conditionIndexes.length > 10) {
        return setmsg({
          type: "setMessage",
          payload: {
            ...data,
            open: true,
            type: "error",
            message: "MeasureConditionは10個が上限です"
          }
        });
      }
    
      const urlPatternAfterVal = setPointCreateRequest.urlPatterns?.map((urlPattern: any) => (
        {
          "URLパターン": valueToOption(urlPattern.matchType, options_matchtype).label,
          "URL": urlPattern.pattern,
        }
      ))

      let itemList: ItemList[] = [
        {
          key: "測定ポイント名",
          beforeValue: "",
          afterValue: setPointCreateRequest.name,
        },
        {
          key: "CVカテゴリ",
          beforeValue: "",
          afterValue: valueToOption(cvCategory, option_setpoint_cv_category).label,
        },
        {
          key: "アクションカテゴリ",
          beforeValue: "",
          afterValue: valueToOption(actionCategory, option_setpoint_action_category).label,
        },
        {
          key: "測定手法",
          beforeValue: "",
          afterValue: valueToOption(attributeType, option_setpoint_attribute).label,
        },
        {
          key: "イベント名",
          beforeValue: "",
          afterValue: valueToOption(setPointCreateRequest.eventID, options_event).label,
        },
        {
          key: "URLパターン",
          beforeValue: "",
          afterValue: JSON.stringify(urlPatternAfterVal),
        },
      ]
      // 実行時
      ApolloEventRecord({
        eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
        logType: "execute",
        result: "",
        userID: state.userprofile.userId,
        userName: state.userprofile.userName,
        accessToken: state.accesstoken ,
        accountGroupID : state.current.accountGroupId,
        accountGroupName: state.current.accountGroupName,
        accountID : state.current.accountId,
        accountName: state.current.accountName,
        campaignID: "", // キャンペーンID
        campaignName: "", // キャンペーン名
        adGroupID: "", // 広告グループID
        adGroupName: "", // 広告グループ名
        menu: "",
        displayName: "測定ポイント新規登録画面",
        category: "測定ポイント",
        actionType: "作成",
        targetID: "",
        targetName: "",
        itemList: itemList,
      });

      setProcessing(true);
      await axios.post(
        url,
        setPointCreateRequest,
        {
          headers: {
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${state.accesstoken}`,
          }
        })
        .then((result) => {
          if (result.data.resultcode === 0) {
            isSuccess = true;
            if (result.data.result) {
              targetID = result.data.result[0].ID;
              targetName = setPointCreateRequest.name;
            }
            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: "success",
                message: "測定ポイント新規登録に成功しました"
              }
            });
          } else {
            console.log(result.data.message);
            const type: string = result?.data?.message === "有効可能上限数エラー" ? "warning" : "error"
            const message: string = result?.data?.message === "有効可能上限数エラー" ? WARNING_MESSAGE[0] : "測定ポイント新規登録に失敗しました"
            setmsg({
              type: "setMessage",
              payload: {
                ...data,
                open: true,
                type: type,
                message: message
              }
            });
          }
        })
        .catch(() => {
          setmsg({
            type: "setMessage",
            payload: {
              ...data,
              open: true,
              type: "error",
              message: "測定ポイント新規登録に失敗しました"
            }
          });
        }).finally(() => {
          // 実行結果
          ApolloEventRecord({
            eventDate: moment().format("YYYY-MM-DD HH:mm:ss"),
            logType: "result",
            result: isSuccess? "成功" : "失敗",
            userID: state.userprofile.userId,
            userName: state.userprofile.userName,
            accessToken: state.accesstoken ,
            accountGroupID : state.current.accountGroupId,
            accountGroupName: state.current.accountGroupName,
            accountID : state.current.accountId,
            accountName: state.current.accountName,
            campaignID: "", // キャンペーンID
            campaignName: "", // キャンペーン名
            adGroupID: "", // 広告グループID
            adGroupName: "", // 広告グループ名
            menu: "",
            displayName: "測定ポイント新規登録画面",
            category: "測定ポイント",
            actionType: "作成",
            targetID: targetID,
            targetName: targetName,
            itemList: itemList,
          });

          setProcessing(false);

            if (isSuccess) {
            history.goBack();
          }
        })
      }
  });

  return (
    <GenericTemplate title="" >
      <CustomizedSnackbars />
      <ApolloPageUsagePermission role={APOLLO_GROUP_OPERATOR} profile={APOLLO_SYSTEM_ADMIN}>
        <ApolloBreadcrumbs bread_no={55} zeusaccountid={0} zeuscampaignid={0} adgroupid={0} adid={0} query={""} platform={""}/>
        <form noValidate onSubmit={onSubmit}>
          <Card className={classes.root} square variant="outlined">
            <CardContent>
                <Grid container spacing={3}>
                  <Grid item xs={12}>
                    <TextField
                      required
                      id="trackerid"
                      name="trackerid"
                      label="トラッカーID1"
                      inputRef={register}
                      fullWidth
                      disabled
                      defaultValue={trackerId} />
                  </Grid>
                  <Grid item xs={12}>
                    <TextField
                      id="name"
                      name="name"
                      required
                      inputRef={register({
                        required: "必須入力項目です。",
                        maxLength: {
                          value: 128,
                          message: "128文字以内で入力して下さい。"
                        },
                        validate: (e: string) => {
                          const errorMessage = checkInvalidCharForName(e)
                          if(errorMessage) {
                            return errorMessage
                          }},
                      })}
                      label="測定ポイント名"
                      fullWidth
                      autoComplete="測定ポイント名"
                      defaultValue=""
                      helperText={errors?.name?.message}
                      error={errors?.name ? true : false} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      CVカテゴリ
                    </Typography>
                    <Controller
                      id="cvCategory"
                      name="cvCategory"
                      render={() => (
                        <Select
                            onChange={(e) => handleChangeCvCategory(e)}
                            value={cvCategory ? option_setpoint_cv_category.find((v) => v.value === cvCategory) : option_setpoint_cv_category[0]}
                            options={option_setpoint_cv_category}
                            key={option_setpoint_cv_category.length > 0 ? "Loaded" : "Loading"}
                        />
                      )}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={option_setpoint_cv_category.length > 0 ? "Loaded" : "Loading"}
                      defaultValue={option_setpoint_cv_category[0].value}
                      options={option_setpoint_cv_category}
                      control={control} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      アクションカテゴリ
                    </Typography>
                    <Controller
                      id="actionCategory"
                      name="actionCategory"
                      render={() => (
                        <Select
                            onChange={(e) => handleChangeActionCategory(e)}
                            value={actionCategory ? option_setpoint_action_category.find((v) => v.value === actionCategory) : option_setpoint_action_category[0]}
                            options={option_setpoint_action_category}
                            key={option_setpoint_action_category.length > 0 ? "Loaded" : "Loading"}
                            menuPosition="fixed"
                        />
                      )}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={option_setpoint_action_category.length > 0 ? "Loaded" : "Loading"}
                      defaultValue={option_setpoint_action_category[0].value}
                      options={option_setpoint_action_category}
                      control={control} />
                  </Grid>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      測定手法
                    </Typography>
                    <Controller
                      id="attributeType"
                      name="attributeType"
                      render={() => (
                        <Select
                            onChange={(e) => handleChangeStatus(e)}
                            value={attributeType ? option_setpoint_attribute.find((v) => v.value === attributeType) : {value:0, label:""}}
                            options={option_setpoint_attribute}
                            key={option_setpoint_attribute.length > 0 ? "Loaded" : "Loading"}
                        />
                      )}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={option_setpoint_attribute.length > 0 ? "Loaded" : "Loading"}
                      defaultValue={option_setpoint_attribute.length > 0 && option_setpoint_attribute[1].value}
                      options={option_setpoint_attribute}
                      control={control} />
                  </Grid>
                { attributeType === 2 &&
                  <Grid item xs={12}>
                    <TextField
                      id="eventParameter"
                      name="eventParameter"
                      required
                      inputRef={register({
                        required: "必須入力項目です。",
                        pattern: {
                            value: /^[a-zA-Z0-9.!#$%&'*+\/=?^_`{|}~-]+$/,
                            message: '入力文字列の形式が正しくありません。'
                        }
                      })}
                      label="計測地点識別パラメータ名"
                      fullWidth
                      autoComplete="計測地点識別パラメータ名"
                      defaultValue=""
                      helperText={errors?.eventParameter?.message}
                      error={errors?.eventParameter ? true : false} />
                  </Grid>
                }
                { attributeType === 1 &&
                <Grid item xs={12}>
                  <Typography variant="subtitle1" gutterBottom>
                    測定条件
                  </Typography>
                  <Grid item xs={12}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      イベント名
                    </Typography>
                    <Controller
                      id="EventID"
                      name="EventID"
                      as={Select}
                      closeMenuOnSelect={true}
                      components={animatedComponents}
                      key={options_event.length > 0 ? "Loaded" : "Loading"}
                      defaultValue={options_event.length > 0 && options_event[0]}
                      options={options_event}
                      menuPlacement="top"
                      control={control} />
                  </Grid>
                  <Grid item xs={12} style={{ marginTop: "10px" }}>
                    <Typography variant="subtitle1" gutterBottom component="div">
                      URLパターン
                    </Typography>
                    <MeasureConditions conditionIndexes={conditionIndexes}
                      addConditions={addConditions}
                      removeConditions={removeConditions}
                      formHooks={formHooks} />
                  </Grid>
                </Grid>
            }
            </Grid>
          </CardContent>
          <CardActions className={classes.cardaction}>
            { attributeType !== 0 &&
              <Button
                  type="submit"
                  color="primary"
                  className={classes.button}
                  variant="contained"
                  disabled={!canSubmit}
              >
                  登録
                </Button>
            }
              <Button
                variant="contained"
                color="primary"
                onClick={handelGoback}
                className={classes.button}
                disabled={formState.isSubmitting || processing}
              >
                戻る
              </Button> 
            </CardActions>
          </Card>
        </form>
      </ApolloPageUsagePermission>
    </GenericTemplate>
  );
};

export default HeraSetPointEdit;
